import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import { AbstractControl,FormBuilder,FormGroup,ReactiveFormsModule, ValidationErrors,Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerModule, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {PocService} from "../../../../services/poc-service/poc.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {ShortClientDto} from "../../../_models/client.dtos";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { LaboService } from '../../../../services/labo-service/labo.service';
import { FournisseurService } from '../../../../services/fournisseur-service/fournisseur.service';
import { MouvementStocktDTO } from '../../../_models/MouvementStockDTO';
import { MouvementStocktService } from '../../../../services/mouvementStock-service/mouvementStock.service';
import { ProduitStocktService } from '../../../../services/produit-service/produit.service';
import { MatNativeDateModule } from '@angular/material/core';
import { ProduitStockDTO } from '../../../_models/ProduitStockDTO';
import { AnalyseDTO } from '../../../_models/analyse.dtos';
import { AnalyseService } from '../../../../services/analyse-service/analyse.service';

@Component({
    standalone: true,
    providers: [HandleErrorsService, ApiService, Endpoints, DialogService, PocService, ClientsService],
    imports: [
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerModule,
    MatNativeDateModule, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, DatePipe, MatCheckbox
    ],

  selector: 'app-mouvement',
  templateUrl: './mouvement.component.html',
  styleUrl: './mouvement.component.scss'
})
export class MouvementComponent {
    @Input() clientsPoc: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    editForm: FormGroup;
    form: FormGroup;
    clientList: ShortClientDto[]
    dataSource = new MatTableDataSource<MouvementStocktDTO>();
    searchValue: string = ''
    mouv?: MouvementStocktDTO
    loadingTable: boolean = true;
    produits:ProduitStockDTO[] = [];
displayedColumns: string[] = [
  'type',  
  'produitStockId',         
  'date',           
  'quantite',       
  'destination',    
  'motif',          
  'utilisateurId',    
];

    columns: string[] = [...this.displayedColumns];
    analysesList:AnalyseDTO[] = [];
    constructor(
        private cookieService: CookieService,
        private handleErrorsService: HandleErrorsService,
        private mouvementStockService: MouvementStocktService,
        private productStockService: ProduitStocktService,
        private analyseService: AnalyseService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
    }

    ngOnInit(): void {
        this.fetchMouvementList()
        this.initializeEditForm();
        this.initializeCreateForm()
        this.getColsCookie()
        this.loadProducts()
        this.loadAnalyseList()

    this.form.get('destination')?.valueChanges.subscribe(dest => {
      const motifControl = this.form.get('motif');
      if (dest === 'Analyse') {
        motifControl?.setValidators([Validators.required]);
        motifControl?.setValue(''); // reset
      } else {
        motifControl?.clearValidators();
        motifControl?.setValue(''); // reset
      }
      motifControl?.updateValueAndValidity();
    });
    }

fetchMouvementList(): void {
  this.mouvementStockService.getAllMouvements().subscribe({
    next: (mouvement) => {
      console.log('✅ Fournisseurs actifs reçus:', mouvement);
      this.dataSource.data = mouvement;
    },
    error: (err) => {
      console.error("❌ Erreur :", err);
    }
  });
}

    loadProducts(): void {
  this.productStockService.getAllProducts().subscribe(data => {
    this.produits = data;
  });
}

loadAnalyseList(): void {
  this.analyseService.findAllInProgressAnalysesStock().subscribe(data => {
    this.analysesList = data;
  });
}
    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    private initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
    }

initializeEditForm() {
  this.editForm = this.fb.group({
    id: ['', Validators.required],
    type: ['', Validators.required],             // 'ENTREE' | 'SORTIE'
    date: ['', Validators.required],             // date ISO ou Datepicker
    quantite: ['', [Validators.required, Validators.min(1)]],
    destination: [''],                            // facultatif (sauf peut-être pour ENTREE)
    motif: [''],                                 // obligatoire si type = 'SORTIE' (validation à gérer)
    produitStockId: ['', Validators.required],  // produit concerné
    utilisateurName: [''],                        // lecture seule ou automatique
  });
}

initializeCreateForm() {
  this.form = this.fb.group({
    type: ['', Validators.required],
    date: ['', Validators.required],
    quantite: ['', [Validators.required, Validators.min(1)]],
    destination: [''],
    motif: [''],
    produitStockId: ['', Validators.required],
    utilisateurName: [''],
  });
}

    public phoneValidator(control: AbstractControl): ValidationErrors | null {
        const validPhonePattern = /^[+\d][\d\s-]*$/;
        return validPhonePattern.test(control.value) ? null : { invalidPhone: true };
    }

onDestinationChange() {
  const destination = this.editForm.get('destination')?.value;
  if (destination === 'Analyse') {
    this.editForm.get('motif')?.setValidators([Validators.required]);
  } else {
    this.editForm.get('motif')?.setValidators([Validators.required]);
  }
  this.editForm.get('motif')?.updateValueAndValidity();
}

      
    openEditModal(mouvement: MouvementStocktDTO) {
          console.log("Mouvement sélectionné pour édition :", mouvement); 
            this.editForm.patchValue({
            id: mouvement.id,
            type: mouvement.type,
            date: mouvement.date,
            quantite: mouvement.quantite,
            destination: mouvement.destination,
            motif: mouvement.motif,
            produitStockId: mouvement.produitStockId ,
            utilisateurName: mouvement.utilisateurName
            });
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

saveMouvement(): void {
    if (this.form.valid) {
        const mouvementToSend = {
            ...this.form.value,
            date: this.form.value.date ? this.formatDate(this.form.value.date) : null
        };

        console.log("📦 Données envoyées :", mouvementToSend);

        this.mouvementStockService.createMouvement(mouvementToSend).subscribe({
            next: response => {
                this.form.reset();
                this.fetchMouvementList();
                this.modalService.dismissAll();
                this.dialogService.openSuccessDialog("Mouvement de stock ajouté avec succès.");
            },
  error: (err) => {
    if (err.error && err.error.message) {
      this.dialogService.openSuccessDialog( err.error.message);
    } else {
         this.dialogService.openSuccessDialog( 'Une erreur inattendue est survenue.');                     
    }            }
        });
    } else {
        this.dialogService.openInvalidFormDialog();
    }
}
formatDate(date: Date): string {
    const d = new Date(date);
    const month = '' + (d.getMonth() + 1);
    const day = '' + d.getDate();
    const year = d.getFullYear();

    return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
}
updateMouvement() {
  console.log("Validation du formulaire :", this.editForm.valid);
  console.log("Valeurs du formulaire :", this.editForm.value);

  if (!this.editForm.valid) {
    console.warn("Formulaire invalide, affichage des erreurs par champ:");
    Object.keys(this.editForm.controls).forEach(field => {
      const control = this.editForm.get(field);
      if (control && control.invalid) {
        console.warn(`- Champ '${field}' invalide. Erreurs:`, control.errors);
      }
    });
    this.dialogService.openInvalidFormDialog();
    return;
  }

  const formData = { ...this.editForm.value };

  // 🔁 Conversion des dates
  const formatDateToString = (date: any): string | null => {
    if (!date) return null;
    const d = new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString().substring(0, 10);
  };

  formData.datePeremption = formatDateToString(formData.datePeremption);
  formData.dateOuverture = formatDateToString(formData.dateOuverture);
  formData.dateCreation = formatDateToString(formData.dateCreation);
  formData.dateFabrication = formatDateToString(formData.dateFabrication);

  console.log("Objet envoyé au service:", formData);

  this.mouvementStockService.updateMouvement(formData.id, formData).subscribe({
    next: response => {
      console.log("✅ Réponse du backend:", response);
      this.updateTableRow(response);
      this.modalService.dismissAll();
      this.dialogService.openSuccessDialog("Mouvement de stock modifié avec succès.");
    },
    error: error => {
      console.error('❌ Erreur lors de l’envoi du devis:', error);

      let backendMessage = error?.error?.message;

      // 🧠 Si le message est du JSON stringifié, on le parse
      if (typeof backendMessage === 'string') {
        try {
          const parsed = JSON.parse(backendMessage);
          backendMessage = parsed?.message || backendMessage;
        } catch (e) {
          // ce n’est pas du JSON valide, on garde tel quel
        }
      }

      const message = backendMessage
        ? backendMessage
        : 'Une erreur est survenue lors de l’envoi du devis.';

      this.dialogService.openDangerAlert(message);
    },
    complete: () => {
      console.log("✅ Mise à jour terminée.");
      this.initializePaginatorAndSort();
    }
  });
}


    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.confirm('Etes-vous sûr de vouloir supprimer ce mouvement?')
            .then((result: any) => {
                if (result) {
                    this.deleteMouvement(element.id);
                }
            });
    }
    deleteMouvement(id: number) {
        this.mouvementStockService.deleteMouvement(id).subscribe({
            next: response => {
                this.removeTableRow(id);
                this.dialogService.openSuccessDialog('Mouvement de stock supprimé avec succès')
            
            },
            error : err => this.handleErrorsService.catchError(err),
            complete: () => this.initializePaginatorAndSort()
        });
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.dataSource.filter = this.searchValue
    }

    openViewModel(element: MouvementStocktDTO) {
        this.mouv = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});

    }
    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then(
            () => {
                this.form.reset()
            },
            () => {
                this.form.reset()
            }
        );
    }
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`fournisseur_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
    private getColsCookie() {
        const fournisseurCols = this.cookieService.get(`fournisseur_${this.user_name}`); // Get the cookie value

        if (fournisseurCols) {
            this.displayedColumns = JSON.parse(fournisseurCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', fournisseurCols);
        }
    }
}

